import React, { FunctionComponent } from "react"
import { Icon } from "@kuali/pure-ui"
import { useFormContext } from "react-hook-form"

interface RecoveryTimeObjective {
  id: string
  timePeriod: string
  position: number
}

interface RTOData {
  recoveryTimeObjectives: RecoveryTimeObjective[]
}

interface Props {
  onSelectChange: Function
  recoveryTimes: RecoveryTimeObjective[]
  selectedRecoveryTimeId: string
}

const RTOSelect: FunctionComponent<Props> = ({
  recoveryTimes,
  selectedRecoveryTimeId = "1",
  onSelectChange
}): JSX.Element => {
  const { register, errors } = useFormContext()
  const isInvalid = errors && errors.recoveryTimeObjectiveId
  return (
    <div>
      <React.Fragment>
        <fieldset className={isInvalid ? "validation-error stack" : "stack"}>
          <label htmlFor="RTO-selection" ref={register}>
            After an emergency how soon would this function need to be recovered?
            Select one that applies.
          </label>
          <select
            id="RTO-selection"
            onChange={(event: React.SyntheticEvent): void => {
              onSelectChange(event)
            }}
            name="recoveryTimeObjectiveId"
            defaultValue={selectedRecoveryTimeId}
            ref={register({ required: true, minLength: 1 })}
          >
            <option value="">Select Recovery Time Objective</option>
            {recoveryTimes &&
              recoveryTimes.map((recoveryData) => {
                return (
                  <option value={recoveryData.id} key={recoveryData.id}>
                    {recoveryData.timePeriod}
                  </option>
                )
              })}
          </select>
          {isInvalid && (
            <span className="validation-error">
              Recovery Time Objective required <Icon name={"alert-warning"} />
            </span>
          )}
        </fieldset>
      </React.Fragment>
    </div>
  )
}
export default RTOSelect
